"use strict";
// Copyright (C) 2017-2024 Smart code 203358507
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var react_2 = __importDefault(require("@stremio/stremio-icons/react"));
var classnames_1 = __importDefault(require("classnames"));
var stremio_router_1 = require("stremio-router");
var components_1 = require("stremio/components");
var useCalendarDate_1 = __importDefault(require("../../useCalendarDate"));
var Item_less_1 = __importDefault(require("./Item.less"));
var Item = function (_a) {
    var _b;
    var selected = _a.selected, monthInfo = _a.monthInfo, date = _a.date, items = _a.items, profile = _a.profile, onClick = _a.onClick;
    var ref = (0, react_1.useRef)(null);
    var navigateWithOrigin = (0, stremio_router_1.useNavigateWithOrigin)().navigateWithOrigin;
    var toDayMonth = (0, useCalendarDate_1.default)(profile).toDayMonth;
    var _c = (0, react_1.useMemo)(function () { return [
        date.day === (selected === null || selected === void 0 ? void 0 : selected.day),
        date.day === monthInfo.today,
    ]; }, [selected, monthInfo, date]), active = _c[0], today = _c[1];
    var onItemClick = function () {
        onClick && onClick(date);
    };
    var onVideoClick = function (event, target) {
        event.preventDefault();
        event.stopPropagation();
        navigateWithOrigin(target);
    };
    (0, react_1.useEffect)(function () {
        var _a;
        active && ((_a = ref.current) === null || _a === void 0 ? void 0 : _a.scrollIntoView({
            block: 'start',
            behavior: 'smooth',
        }));
    }, [active]);
    return (react_1.default.createElement("div", { ref: ref, className: (0, classnames_1.default)(Item_less_1.default['item'], (_b = {}, _b[Item_less_1.default['active']] = active, _b[Item_less_1.default['today']] = today, _b)), key: date.day, onClick: onItemClick },
        react_1.default.createElement("div", { className: Item_less_1.default['heading'] }, toDayMonth(date)),
        react_1.default.createElement("div", { className: Item_less_1.default['body'] }, items.map(function (_a) {
            var id = _a.id, name = _a.name, season = _a.season, episode = _a.episode, deepLinks = _a.deepLinks;
            return (react_1.default.createElement(components_1.Button, { className: Item_less_1.default['video'], key: id, href: deepLinks.metaDetailsStreams, onClick: function (event) { return onVideoClick(event, deepLinks.metaDetailsStreams); } },
                react_1.default.createElement("div", { className: Item_less_1.default['name'] }, name),
                react_1.default.createElement("div", { className: Item_less_1.default['info'] },
                    "S",
                    season,
                    "E",
                    episode),
                react_1.default.createElement(react_2.default, { className: Item_less_1.default['icon'], name: 'play' })));
        }))));
};
exports.default = Item;
